import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconosGenerales from "../../elementos/iconos/IconosGenerales";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { visuallyHidden } from '@mui/utils';
import { styled } from '@mui/material/styles';
import PaginacionTabla from '../eventos/filtros/SelectPaginaTabla';
import SelectNumeroCursos from '../eventos/filtros/SelectNumeroElementos';
import SelectSubcategoria from '../eventos/filtros/SelectSubcategoria';
import SelectDinamico from '../eventos/filtros/SelectDinamico';
import SelectDinamicoLista from '../eventos/filtros/SelectDinamicoLista';
import BuscadorCursos from '../eventos/filtros/BuscadorDinamico';
import funcionOrdenarColumnas from '../eventos/filtros/OrdenarColumnas';
import { useNavigate } from 'react-router-dom';
import CustomTooltip from './../eventos/avisos/Tooltip';
import { CircularProgress } from "@mui/material";

import BotonesAccion from "../../elementos/eventos/navegacion_y_accion/BotonesAccion";

const StyledTableCell = styled(TableCell)(({ theme,textDefault }) => ({
    textAlign: 'center  !important',
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'rgb(238, 128, 93)',
        color: theme.palette.common.white,
        padding: '0px',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: '14px ',
        textTransform: textDefault ? 'none' :'capitalize',
        padding: '0px',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    textAlign: 'center  !important',
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const WhiteTableSortLabel = styled(TableSortLabel)(({ theme }) => ({
    textAlign: 'center  !important',
    color: `${theme.palette.common.white} !important`,
    '&.Mui-active .MuiTableSortLabel-icon': {
        color: `${theme.palette.common.white} !important`,
    },
}));


function stableSort(array, comparator) {
    const arrayCopy = [...array];
    arrayCopy.sort(comparator);
    return arrayCopy;
}


function EnhancedTableHead(props) {

    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <StyledTableRow>
                <StyledTableCell padding="checkbox">
                    <Checkbox
                        style={{ color: 'white' }}
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />
                </StyledTableCell>
                {props.header.map((headCell) => (
                    <StyledTableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <WhiteTableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </WhiteTableSortLabel>
                    </StyledTableCell>
                ))}
            </StyledTableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};


function EnhancedTableToolbar(props) {
    const { numSelected, proveedores, categorias, subcategorias, requisitos, conPlazas, activos, setOcultarFiltroTodos, setOcultarSeleccion, setActivarFiltroTodos, setActivarSeleccion, isLoading, busqueda } = props;
    const [estadoBusqueda, setEstadoBusqueda] = useState(false);
    const [escribiendo, setEscribiendo] = useState(false);
    console.log("cargando", isLoading);

    const toggleFiltroTodos = (valor, atributo) => {
        console.log("atributo ", atributo);
        if (atributo == "ocultar") {
            setOcultarFiltroTodos((prevState) => ({
                ...prevState,
                valor,
            }));
        }

        if (atributo == "activar") {
            setActivarFiltroTodos((prevState) => ({
                ...prevState,
                valor,
            }));
        }



    };

    const toggleSeleccion = (valor, atributo) => {

        if (atributo == "ocultar") {
            setOcultarSeleccion((prevState) => ({
                ...prevState,
                valor,
            }));
        }
        if (atributo == "activar") {
            setActivarSeleccion((prevState) => ({
                ...prevState,
                valor,
            }));
        }


    };

    return (
        <>
            <Toolbar
                sx={{
                    pl: { sm: 2 },
                    pr: { xs: 1, sm: 1 },
                    ...(numSelected > 0 && {
                        bgcolor: (theme) =>
                            alpha(theme.palette.common.white, theme.palette.action.activatedOpacity),
                    }),
                }}
            >
                {numSelected > 0 ? (
                    <Typography
                        sx={{ flex: '1 1 100%' }}
                        color="inherit"
                        variant="subtitle1"
                        component="div"
                    >
                        {numSelected} seleccionado(s)
                    </Typography>
                ) : (
                    <Typography
                        sx={{ flex: '1 1 40%' }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >

                        <BotonesAccion
                            texto="Crear Curso"
                            convocatoria={true}
                            to="/convocatoria/cursos/crearCurso"
                        />
                    </Typography>
                )}

                {numSelected > 0 ? (
                    <>
                        {[
                            { mensaje: "Activar todos", id: "activarTodo", handler: () => toggleFiltroTodos(true, "activar") },
                            { mensaje: "Activar select", id: "activarSelect", handler: () => toggleSeleccion(true, "activar") },
                            { mensaje: "Eliminar todo", id: "eliminarTodo", handler: () => toggleFiltroTodos(false, "ocultar") },
                            { mensaje: "Eliminar select", id: "eliminarSelect", handler: () => toggleSeleccion(false, "ocultar") },
                        ].map(({ mensaje, id, handler }) => (
                            <CustomTooltip key={id} mensaje={mensaje}>
                                <div
                                    onClick={handler}
                                    style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    width: '40px', 
                                    height: '40px',
                                    }}
                                >
                                    <IconosGenerales papeleraT="true" id={id} style={{width: '24px', height: '24px'}}/>
                                </div>
                            </CustomTooltip>
                        ))}
                    </>
                ) : (
                    <>
                        <SelectDinamicoLista opciones={proveedores} parametroURL="proveedor" etiqueta="Proveedor" />
                        <SelectDinamicoLista opciones={categorias} parametroURL="categoria" etiqueta="Categoria" />
                        <SelectDinamicoLista opciones={requisitos} parametroURL="nivel" etiqueta="Nivel" />
                        <SelectSubcategoria subcategorias={subcategorias} />
                        <SelectDinamico parametroURL="plazas" valor={conPlazas} etiqueta="Plazas" />
                        <SelectDinamico parametroURL="activo" valor={activos} etiqueta="Activo" />

                        <BuscadorCursos
                            placeholder="Buscar curso"
                            tooltip="Ej: Nombre, AF, Horas"
                            palabra={busqueda || ""}
                            estadoBusqueda={estadoBusqueda}
                            setEstadoBusqueda={setEstadoBusqueda}
                            escribiendo={escribiendo}
                            setEscribiendo={setEscribiendo}
                        />

                        <BotonesAccion
                            icono="delete"
                            to="/convocatoria/cursos"
                        />
                    </>
                )}
            </Toolbar>
        </>
    );




}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};


function EnhancedTable(props) {
    console.log("Props", props);
    const navigate = useNavigate();
    const {
        data,
        header,
        meta,
        proveedores,
        categorias,
        subcategorias,
        requisitos,
        conPlazas,
        activo,
        selected,
        setSelected,
        eliminarFiltroTodos,
        eliminarSeleccion,
        setOcultarFiltroTodos,
        setOcultarSeleccion,
        activarFiltroTodos,
        setActivarFiltroTodos,
        activarSeleccion,
        setActivarSeleccion,
        isLoading,
        busqueda
    } = props;

    // console.log("data", data);
    // console.log("headers", header);
    // console.log("meta", meta);

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('categoria');


    // const handleRequestSort = funcionOrdenarColumnas(orderBy, order, setOrderBy, setOrder);

    const handleRequestSort = (event, property) => {
        const nuevaURL = funcionOrdenarColumnas(orderBy, order, setOrderBy, setOrder)(event, property);
        console.log("nuevaURL", nuevaURL);
        navigate(nuevaURL);
    };


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = data.map((n) => n.id);
            setSelected(newSelected);

            return;
        }
        setSelected([]);
        // console.log("seleción", selected);
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };


    const isSelected = (id) => selected.indexOf(id) !== -1;

    const sortedData = stableSort(data);

    return (
        <Box sx={{ width: '100%' }}>
            <div>
                <Paper sx={{ width: '98%', mb: 2 }}>

                    <EnhancedTableToolbar
                        numSelected={selected.length}
                        categorias={categorias}
                        subcategorias={subcategorias}
                        proveedores={proveedores}
                        requisitos={requisitos}
                        conPlazas={conPlazas}
                        activo={activo}
                        eliminarFiltroTodos={eliminarFiltroTodos}
                        setOcultarFiltroTodos={setOcultarFiltroTodos}
                        eliminarSeleccion={eliminarSeleccion}
                        setOcultarSeleccion={setOcultarSeleccion}
                        activarFiltroTodos={activarFiltroTodos}
                        setActivarFiltroTodos={setActivarFiltroTodos}
                        activarSeleccion={activarSeleccion}
                        setActivarSeleccion={setActivarSeleccion}
                        isLoading={isLoading}
                        busqueda={busqueda}

                    />

                    <TableContainer  >
                        <Table sx={{ maxWidth: 2000, minWidth: 1300, }} aria-labelledby="tableTitle">
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={data.length}
                                header={header}
                            />
                            <TableBody>
                                {isLoading ? (
                                    <TableRow hover sx={{ cursor: "default" }}>
                                        <TableCell colSpan={13} style={{ textAlign: "center" }}>
                                            <CircularProgress style={{ color: "rgb(238, 128, 93)" }} />
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    sortedData.map((row, index) => {
                                        const isItemSelected = isSelected(row.id);
                                        const labelId = `enhanced-table-checkbox-${index}`;
                                        console.log("row", row);

                                        return (
                                            <StyledTableRow
                                                hover
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                key={row.id}
                                                selected={isItemSelected}
                                                style={row.activo != 1 ? { backgroundColor: 'rgba(224, 84, 84, 0.2)' } : {}}
                                            >
                                                <StyledTableCell padding="checkbox">
                                                    <Checkbox
                                                        color="default"
                                                        onClick={(event) => handleClick(event, row.id)}
                                                        checked={isItemSelected}
                                                        inputProps={{ 'aria-labelledby': labelId }}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell component="th" id={labelId} scope="row" padding="none" textDefault="true">
                                                    {row.nombre}
                                                </StyledTableCell>
                                                <StyledTableCell align="left">{row.AF}</StyledTableCell>
                                                <StyledTableCell align="left">{row.proveedor}</StyledTableCell>
                                                <StyledTableCell align="left">
                                                    {row.NumPlazas > 0 ? (
                                                        row.NumPlazas
                                                    ) : row.plazasAgotadas == 0 || row.plazasAgotadas == false ? (
                                                        <p >-</p>
                                                    ) : (
                                                        <p style={{ color: 'rgb(224, 84, 84)' }}>Agotadas</p>
                                                    )}

                                                </StyledTableCell>
                                                <StyledTableCell align="left">{row.categoria}</StyledTableCell>
                                                <StyledTableCell align="right">{row.subcategoria}</StyledTableCell>
                                                <StyledTableCell align="right">{row.horas}</StyledTableCell>
                                                <StyledTableCell align="right">{row.nivel}</StyledTableCell>
                                                <StyledTableCell align="right"><IconosGenerales
                                                    tabla="true"
                                                    convocatoria="true"
                                                    id="edit"
                                                    to={`/convocatoria/cursos/editarCurso/${row.editar}`}
                                                /></StyledTableCell>
                                            </StyledTableRow>
                                        );
                                    })
                                )}
                            </TableBody>

                        </Table>
                    </TableContainer>

                </Paper>
            </div>

            {!isLoading && (
                <>
                    <PaginacionTabla
                        totalPages={meta.totalPages}
                        convocatoria="true"
                    />
                    <SelectNumeroCursos
                        perPage={meta.per_page}
                        convocatoria="true"
                    />
                </>
            )}

            <Typography
                variant="body2"
                sx={{
                    mr: '2%',
                    textAlign: 'right',
                    fontWeight: 'bold',
                    fontSize: '16px',
                    gap: "8px", marginTop: "-30px",
                    color: 'rgb(238, 128, 93)',
                }}
                >
                Total registros: {meta.total || 0}
            </Typography>
        </Box>
    );
}

EnhancedTable.propTypes = {
    data: PropTypes.array.isRequired,
    header: PropTypes.array.isRequired,
    meta: PropTypes.object.isRequired,
};

export default EnhancedTable;